import React, { useContext } from "react";

import { BackgroundDialogContext } from "../Context";
import TextInput from "../../MacroSidebar/TextInput";
import VideoIcon from "../Icons/Video";

function Video() {
  const { image, setImage, linkToDocs } = useContext(BackgroundDialogContext);

  return (
    <>
      <TextInput
        value={image.source === "video" ? image?.link : ""}
        setValue={(newValue) => {
          if (newValue) {
            setImage({ source: "video", link: newValue, id: "" });
          } else {
            setImage({ source: "color", value: "#f9fbfc" });
          }
        }}
        placeholder="https://www.caelor.com"
      />

      <div style={{ textAlign: "center", marginTop: "40px" }}>
        <VideoIcon />

        <h2 style={{ fontWeight: 500 }}>Enter a video link</h2>
        <p>
          Paste a Video Address to preview.
          <br />
          <a
            href={linkToDocs}
            target="_blank"
            rel="noreferrer"
            style={{
              cursor: "pointer",
              color: "#0038a9",
              textDecoration: "none",
            }}
          >
            Have trouble adding a video via link?
          </a>
        </p>
      </div>
    </>
  );
}

export default Video;
